import { useSubscription } from './useSubscription';
import { Message, LogMessage } from 'types';

export const useModelLogs = (id: string): Nullable<Message<LogMessage>> =>
  useSubscription(`$experiment-${id}-logs`);
